import { type FeatureFlagPayloadMap } from '@posthog-app/use-feature-flag.type';

/**
 * Defensive read of the `floorplan-interactive-editor` flag + payload. Returns
 * false if the payload is malformed (missing `allowedCompanyIds`, wrong type),
 * so a bad edit in the PostHog UI can't break floorplan navigation.
 *
 * An explicit `allCompanies: true` in the payload opts every company in without
 * enumerating IDs — a single deliberate PostHog edit. The boolean flag is still
 * required, and the sentinel must be the literal `true`, so the gate stays
 * fail-closed for empty or malformed payloads.
 */
export const shouldShowFloorplanV2 = (
  isFlagEnabled: boolean,
  payload: FeatureFlagPayloadMap['floorplan-interactive-editor'] | undefined,
  companyLegacyId: string
): boolean => {
  if (!isFlagEnabled) {
    return false;
  }

  if (payload?.allCompanies === true) {
    return true;
  }

  const allowedCompanyIds = payload?.allowedCompanyIds;
  return Array.isArray(allowedCompanyIds) && allowedCompanyIds.includes(Number(companyLegacyId));
};
